import { createSelector } from '@ngrx/store';
import { UserState } from './user.state';

export const getUserState = (state: { user: UserState }) => state.user;

export const getUser = createSelector(
  getUserState,
  (userState: UserState) => userState
);

export const isLoggedIn = createSelector(
  getUserState,
  (userState: UserState) => userState.isLoggedIn
);

export const getAuthorization = createSelector(
    getUserState,
    (userState: UserState) => userState.authorization
  );

  export const getRoles = createSelector(
    getUserState,
    (userState: UserState) => userState.roles
  );

  export const getGroups = createSelector(
    getUserState,
    (userState: UserState) => userState.groups
  );

  export const  getAuthorizationByModule = createSelector(
    getUserState,
    (userState: UserState) => (moduleName:string)  =>  {
      userState.authorization.forEach( (element : any) => {
        if (element.name == moduleName){
          return element // {name: MonModule, role: "ACTEUR"}

        }
      });
    }
  )